import { speakText, stopSpeaking } from './TextToSpeech';

let playbackToken = 0;

function waitForAudioEnd (audio) {
    return new Promise((resolve) => {
        if (!audio.media) {
            resolve();
            return;
        }
        const onEnd = () => {
            audio.media.removeEventListener('ended', onEnd);
            resolve();
        };
        audio.media.addEventListener('ended', onEnd);
    });
}

async function ensureAudioReady (audio) {
    if (audio.exists && audio.media) {
        return;
    }
    if (audio.promiseMedia) {
        try {
            await audio.promiseMedia;
        } catch (e) {
            // ignore
        }
        if (audio.exists && audio.media) {
            return;
        }
    }
    if (!audio.exists) {
        await audio.download();
    }
    if (audio.promiseMedia) {
        await audio.promiseMedia;
    }
}

async function playAudioMessage (audio, pauseAll) {
    await ensureAudioReady(audio);
    if (!audio.media) {
        return;
    }
    pauseAll();
    audio.play();
    await waitForAudioEnd(audio);
}

/**
 * @param {Array} messages - unread messages, chronological
 * @param {{ pauseAll: Function }} hooks
 * @returns {Promise<boolean>} true if queue finished (not cancelled)
 */
export async function playUnreadMessagesQueue (messages, { pauseAll }) {
    const token = ++playbackToken;
    for (const message of messages) {
        if (token !== playbackToken) {
            return false;
        }
        if (message.type === 1 && message.audio) {
            try {
                await playAudioMessage(message.audio, pauseAll);
            } catch (e) {
                console.warn('MessagePlayback audio failed', e);
            }
        } else if (message.type === 0 && message.mensaje) {
            pauseAll();
            await speakText(message.mensaje);
        }
    }
    return token === playbackToken;
}

export function stopUnreadPlayback (pauseAll) {
    playbackToken++;
    stopSpeaking().catch(() => {});
    if (pauseAll) {
        pauseAll();
    }
}

export function isPlaybackCancelled (token) {
    return token !== playbackToken;
}



// WEBPACK FOOTER //
// ./src/services/MessagePlayback.js